import axios from 'axios';
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

let map;
let mapMarkerArray = [];

setOptions({
  key: process.env.GOOGLE_MAPS_API_KEY,
  v: "weekly",
});

const mapOptions = {
  center: {
    lat: 0,
    lng: 0
  },
  zoom: 4
};

const defaultBounds = {
  north: mapOptions.center.lat + 0.1,
  south: mapOptions.center.lat - 0.1,
  east: mapOptions.center.lng + 0.1,
  west: mapOptions.center.lng - 0.1,
};

let useLocation = 0;

const googleMaps = {

  async initAutocomplete (selector) {

    let address0Field = document.querySelector(`${selector}-address`);
    let address1Field = document.querySelector(`${selector}-address-street`);
    let address2Field = document.querySelector(`${selector}-address-exterior-number`);
    let postalField = document.querySelector(`${selector}-zipcode`);

    const { Autocomplete } = await importLibrary("places");
    const autocomplete = new Autocomplete(address0Field, {
      bounds: defaultBounds,
      componentRestrictions: { country: JSON.parse(process.env.GOOGLE_MAP_COUNTRY) },
      fields: ["address_components", "geometry"],
      types: ["address"],
      strictBounds: false, // Must change to true?
    });
    document.querySelector(`${selector}-address`).focus();
  
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    autocomplete.addListener("place_changed", () => {
      // Get the place details from the autocomplete object.
      const place = autocomplete.getPlace();
      let address1 = "";
      let postcode = "";
  
      for (const component of place.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0];
  
        // Just for testing
        // console.log("Key value: ", componentType, " | Long name:", component.long_name, " | Short name: ", component.short_name);
        // End testing
  
        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case "route": {
            address1 += component.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case "postal_code_suffix": {
            postcode = `${postcode}-${component.long_name}`;
            break;
          }
          case "neighborhood": {
            //console.log("neighborhood: ", component.long_name);
            break;
          }
          case "sublocality_level_1": {
            //console.log("sublocality_level_1: ", component.long_name);
            break;
          }
          case "locality": {
            document.querySelector(`${selector}-locality`).value = component.long_name;
            //console.log("locality: ", component.long_name);
            break;
          }
          case "administrative_area_level_1": {
             //document.querySelector(`${selector}-state`).value = component.short_name;
             //console.log("administrative_area_level_1: ", component.short_name);
            break;
          }
          // }
           case "country":
            //document.querySelector(`${selector}-country`).value = component.long_name;
            //console.log("country: ", component.long_name);
          break;
        }
      }
      address1Field.value = address1;
      postalField.value = postcode;
      address2Field.focus();
    });
  },

  async initSearchBox (selector, useLocations) {
    useLocation = (useLocations !== undefined && useLocations === 1) ? 1 : 0;

    const { Map, InfoWindow } = await importLibrary("maps");
    const { Autocomplete } = await importLibrary("places");
    const { Marker, AdvancedMarkerElement } = await importLibrary("marker");

    const myCoords = { lat: 52.5000, lng: 5.7500 };

    map = new Map(document.getElementById(`${selector}-map`), {
      center: myCoords,
      zoom: 8,
      mapTypeControl: false,
      mapId: process.env.GOOGLE_MAP_ID,
    });

    const card = document.getElementById(`${selector}-pac-card`);
    const input = document.getElementById(`${selector}-pac-input`);
    const options = {
      fields: ["formatted_address", "geometry", "name"],
      componentRestrictions: { country: JSON.parse(process.env.GOOGLE_MAP_COUNTRY) },
      strictBounds: false,
    };

    let google = window.google;
    map.controls[google.maps.ControlPosition.TOP_CENTER].push(card);

    const autocomplete = new Autocomplete(input, options);
    autocomplete.bindTo("bounds", map);

    const infoWindow = new InfoWindow();
    const infoWindowContent = document.getElementById(`${selector}-info-window-content`);
    infoWindow.setContent(infoWindowContent);

    map.addListener("click", async (e) => {
      this.clearOverlays();
      const advMarker = new AdvancedMarkerElement({
        position: e.latLng,
        map: map,
      });

      let result = JSON.parse(JSON.stringify(e.latLng));
      let response = await this.reverseGeocoding(result);

      if (response.status === 200){

        const place = response.data.results[0];
        document.getElementById(`${selector}-place-address`).value = place.formatted_address;
        document.getElementById(`${selector}-pac-input`).value = place.formatted_address;
        infoWindowContent.children[`${selector}-place-name-on-map`].textContent = place.name;
        infoWindowContent.children[`${selector}-place-address-on-map`].textContent = place.formatted_address;

        infoWindow.open(map, advMarker);

        if (useLocation > 0) await this.getLocalities(result, selector);
      } 
      else {
        console.log("No results found");
      }

      document.getElementById(`${selector}-place-coords-latitude`).value = result.lat;
      document.getElementById(`${selector}-place-coords-longitude`).value = result.lng;

      mapMarkerArray.push(advMarker);
      map.panTo(e.latLng);
    });

    const marker = new Marker({
      map,
      anchorPoint: new google.maps.Point(0, -29),
    });

    autocomplete.addListener("place_changed", async () => {
      infoWindow.close();
      marker.setVisible(false);

      const place = autocomplete.getPlace();

      if (!place.geometry || !place.geometry.location) {
        console.log("No details available for input: '" + place.name + "'");
        return;
      }

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }

      marker.setPosition(place.geometry.location);
      marker.setVisible(true);

      document.getElementById(`${selector}-place-address`).value = place.formatted_address;

      infoWindowContent.children[`${selector}-place-name-on-map`].textContent = place.name;
      infoWindowContent.children[`${selector}-place-address-on-map`].textContent = place.formatted_address;
      infoWindow.open(map, marker);

      if (useLocation > 0) await this.getLocalities(place.geometry.location, selector);

    });
  },

  async getLocalities (coords, selector) {
    const request = {
      // Required parameters.
      fields: ["displayName", "location", "businessStatus"],
      locationRestriction: {
        center: coords,
        radius: 20000,  // 20 km in meters
      },
      // Optional parameters.
      includedPrimaryTypes: ["locality"],
    };

    const { Place } = await importLibrary("places");
    const { places } = await Place.searchNearby(request);
    if (places.length) {
      const localitiesNames = places.map(place => place.displayName);
      document.getElementById(`${selector}-place-address`).value = localitiesNames[0];
      document.getElementById(`${selector}-place-locations-list`).value = localitiesNames.toString();
    }
  },

  async reverseGeocoding (coords) {
    return await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.lat},${coords.lng}&key=${process.env.GOOGLE_MAPS_API_KEY}`);
  },

  async initLocationMap (selector, city, country){
    const { Map } = await importLibrary("maps");

    let response = await this.dataByLocatityText(city, country);
    if (response.status !== 200){
      console.log("Data not ok :(");
      return;
    }

    const result = response.data.results[0];
    const coords = {
      // lat: (city.length > 0) ? result.navigation_points[0].location.latitude : result.geometry.location.lat,
      // lng: (city.length > 0) ? result.navigation_points[0].location.longitude : result.geometry.location.lng,
      lat: result.geometry.location.lat,
      lng: result.geometry.location.lng,
    }

    const myCoords = { lat: coords.lat, lng: coords.lng };

    map = new Map(document.getElementById(`${selector}-map`), {
      center: myCoords,
      zoom: 8,
      mapTypeControl: false,
      mapId: process.env.GOOGLE_MAP_ID,
    });
  },

  async dataByLocatityText(city, country) {
    let location = (city === null || city === undefined) ? `${country}` : `${city},${country}`
    return await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${location}&key=${process.env.GOOGLE_MAPS_API_KEY}`);
  },

  clearOverlays() {
    for (var i = 0; i < mapMarkerArray.length; i++) {
      mapMarkerArray[i].setMap(null);
    }
    mapMarkerArray = []; // Reset the array
  },
};

export default googleMaps;
